<p>memory-color-game-page works!</p>
